
import React, { Component } from 'react';

import { withRouter, Redirect } from 'react-router-dom'
import { DataTable,DataTableStateEvent } from 'primereact/datatable';
import { Column, ColumnFilterElementTemplateOptions } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { withNamespaces } from 'react-i18next';
import { baseUrl } from '../../../Comman/apiEndPoints';

import Modal from 'react-responsive-modal';
export const ALARM_LIST_SUCCESS = "(feedback) ALARM_LIST_SUCCESS";

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

class IncomingAlarmListComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            openAlarm:false,
            expandedRows: null,
            RegionId:'',
            sortField:'',
            sortOrder:null

        }
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this); 
        this.openModal2 = this.openModal2.bind(this);
        this.closeModal2 = this.closeModal2.bind(this);
        this.actionColumn = this.actionColumn.bind(this); 
        this.actionColumn1 = this.actionColumn1.bind(this); 
        this.actionColumn2 = this.actionColumn2.bind(this); 
    }
    // rowClassName(rowData) {
    //     // let IsEnabled = rowData.IsEnabled;
    //     return { 'p-highlight': (rowData) };

    // }
    formatCreatedDate(rowData) {
        if (rowData.CreatedDate != null && rowData.CreatedDate != undefined) {
            if (rowData.CreatedDate == "0001-01-01T00:00:00") {
                return;
            }
            else {
                let value = rowData.CreatedDate.split('T');
               
                let data = value[1].split(':');
                let sec=data[2].split('.')
                return value[0] + " " + data[0] + ":" + data[1] + ":" + sec[0]
            }
        }
    }
    formatClosedDate(rowData) {
        if (rowData.ClosedDate != null && rowData.ClosedDate != undefined) {
            if (rowData.ClosedDate == "0001-01-01T00:00:00") {
                return;
            }
            else {
                let value = rowData.ClosedDate.split('T');
                let data = value[1].split(':');
           let sec=data[2].split('.')
                return data[0] + ":" + data[1] + ":" + sec[0]
            }
        }
    }
    formatUpdatedDate(rowData) {
        if (rowData.UpdatedTime != null && rowData.UpdatedTime != undefined) {
            if (rowData.UpdatedTime == "0001-01-01T00:00:00") {
                return;
            }
            else {
                let value = rowData.UpdatedTime.split('T');
                let data = value[1].split(':');
                 let sec=data[2].split('.')
                return value[0] + " " + data[0] + ":" + data[1] + ":" + sec[0]
            }
        }
    }
     formatUpdatedDate1(rowData) {
        if (rowData.UpdatedDate != null && rowData.UpdatedDate != undefined) {
            if (rowData.UpdatedDate == "0001-01-01T00:00:00") {
                return;
            }
            else {
                let value = rowData.UpdatedDate.split('T');
                let data = value[1].split(':');
                 let sec=data[2].split('.')
                return value[0] + " " + data[0] + ":" + data[1] + ":" + sec[0]
            }
        }
    }
    formatDefibPos(rowData) {
        if (rowData.DefibPosLat && rowData.DefibPosLon) {
            return `${rowData.DefibPosLat},${rowData.DefibPosLon}`

         

        }
        else{
            return
        }
    }
    formatUserPos(rowData) {
        if (rowData.PosLat && rowData.PosLon) {
            return `${rowData.PosLat},${rowData.PosLon}`

        }
        else{
            return
        }
    }
    formatUserPos1(rowData) {
        if (rowData.PosLat && rowData.PosLon) {
             return `${rowData.PosLat},${rowData.PosLon}`

        }
        else{
            return
        }
    }
    formatAlarmPos(rowData) {
        if (rowData.AlarmPosLat && rowData.AlarmPosLon) {
            return `${rowData.AlarmPosLat}, ${rowData.AlarmPosLon}`

        }
        else{
            return
        }
    }
    formatAddressAlarm(rowData) {
        if (rowData.Floor || rowData.Street || rowData.City) {

            return (<p>{rowData.Floor + (rowData.Street ? ','+ rowData.Street :'') + (rowData.City ? ','+ rowData.City :'') }</p>)

        }
        else{
            return
        }
    }
    patientFullname(data) {
        return data.FirstName + ' ' + data.LastName;
    }
    showImage(data) {
        if(data.Image) {
            return <img src={baseUrl + data.Image} width="50px" />
        }
        else {
            return '';
        }
    }
    actionColumn(rowDatas) {  
        const { t } = this.props;
            return (
                <span>
                    <span onClick={() => { this.openModal(rowDatas) }} className="enable-cursor editicon" title={t('First_Responder.View')}>   
                        <i className="fa fa-file-image-o" aria-hidden="true"></i></span> 
                </span>
            )
    }
    actionColumn1(data) {  
        const { t } = this.props;
            return (
                <span>
                    <button type='button' onClick={() => { this.openImage(data) }} className="btn btn-primary enable-cursor editicon"> 
                    {t('First_Responder.Open')}  
                    </button> 
                </span>
            )
    }
    actionColumn2(rowDatas) {
        const { t } = this.props;
            return (
                <span>
                    <span onClick={() => { this.openModal2(rowDatas) }} className="enable-cursor editicon" title={t('First_Responder.Log')}>   
                        <i className="fa fa-history" aria-hidden="true"></i></span> 
                </span>
            )
    }
    openImage(data){
        let image = baseUrl + data.Image
        window.open(image, "_blank")
    }
    openModal(rowDatas) { 
        let payload = {
            MissionId : rowDatas.MissionId
        }
        this.props.getImageListData(payload)
        this.setState({ open: true })   
    }
    openModal2(rowDatas) { 
        let payload = {
            UserId:rowDatas.UserId,
            AlarmId:rowDatas.AlarmId
        }
        this.props.getAlarmReceiverListData(payload)
        this.setState({ openAlarm: true })   
    }
 
    RefreshData()
    {
        let payload = {
            RegionId:  this.state.RegionId == '' ? (this.props.incomingAlarmList.regionList.length > 0 ? this.props.incomingAlarmList.regionList[0].ID : null) : this.state.RegionId,
            IsShowAllAlarm: this.state.RegionId == 0 ? true : false,
             SortField: "CreatedDate",
    SortOrder: 2
        }
        this.props.getUserList(payload)
    }

    closeModal() {
        this.setState({ open: false });
    }
    closeModal2() {
        this.setState({ openAlarm: false });
    }
    rowExpansionTemplate = (data) => {
        const { t } = this.props;
        return (
            <div className="orders-subtable">
                <h4>{t('First_Responder.Receiver list')}</h4>
                <div className="incoming-alarm-count">
                <button style={{ backgroundColor: '#0e11e1' }} type="button" disabled className="notification-badge btn btn-primary">Receive Alarm <span className="badge bg-secondary">{data.alarmReceiverList.length > 0 ? data.alarmReceiverList[0].ReceiveAlarmCount : 0}</span></button>
                <button style={{ backgroundColor: '#067e24' }} type="button" disabled className="notification-badge btn btn-success">Accept Alarm <span className="badge bg-secondary">{data.alarmReceiverList.length > 0 ? data.alarmReceiverList[0].AcceptAlarmCount : 0}</span></button>
                <button style={{ backgroundColor: '#e6931c' }} type="button" disabled className="notification-badge btn btn-warning">Abort Alarm <span className="badge bg-secondary">{data.alarmReceiverList.length > 0 ? data.alarmReceiverList[0].AbortAlarmCount : 0}</span></button>
                <button style={{ backgroundColor: '#ff0e07' }} type="button" disabled className="notification-badge btn btn-danger">Close Alarm <span className="badge bg-secondary">{data.alarmReceiverList.length > 0 ? data.alarmReceiverList[0].CloseAlarmCount : 0}</span></button>
                <button style={{ backgroundColor: '#028df8' }} type="button" disabled className="notification-badge btn btn-info">Reject Alarm <span className="badge bg-secondary">{data.alarmReceiverList.length > 0 ? data.alarmReceiverList[0].RejectAlarmCount : 0}</span></button>
                <button style={{ backgroundColor: '#f84102' }} type="button" disabled className="notification-badge btn btn-secondary">Go To Defibrillator <span className="badge bg-secondary">{data.alarmReceiverList.length > 0 ? data.alarmReceiverList[0].AssignDefibCount : 0}</span></button>
                {/* <button style={{ backgroundColor: '#067e24' }} type="button" disabled class="notification-badge btn btn-dark">Don't Have Defibrillator <span class="badge bg-secondary">{data.alarmReceiverList.length > 0 ? data.alarmReceiverList[0].UnAssignDefibCount : 0}</span></button> */}
                <button style={{ backgroundColor: '#f88102' }} type="button" disabled className="notification-badge btn btn-light">Go To Patient <span className="badge bg-secondary">{data.alarmReceiverList.length > 0 ? data.alarmReceiverList[0].AssignGotoPatientCount : 0}</span></button>
                    {/* <p>Receive Alarm - {data.alarmReceiverList.length > 0 ? data.alarmReceiverList[0].ReceiveAlarmCount : 0}</p>
                    <p>Accept Alarm - {data.alarmReceiverList.length > 0 ? data.alarmReceiverList[0].AcceptAlarmCount : 0}</p>
                    <p>Abort Alarm - {data.alarmReceiverList.length > 0 ? data.alarmReceiverList[0].AbortAlarmCount : 0}</p>
                    <p>Close Alarm - {data.alarmReceiverList.length > 0 ? data.alarmReceiverList[0].CloseAlarmCount : 0}</p>
                    <p>Reject Alarm - {data.alarmReceiverList.length > 0 ? data.alarmReceiverList[0].RejectAlarmCount : 0}</p> */}
                </div>
                
                <DataTable value={data.alarmReceiverList} responsiveLayout="scroll" emptyMessage={t('Feedback Setting.No records found')}>
                    {/* <Column field="Image" header="Profile" body={this.showImage} sortable={true} /> */}
                    <Column field="FirstName" header={t('First_Responder.Name')} body={this.patientFullname} sortable={true} />
                    {/* <Column field="FirstName" header={t('First_Responder.First Name')} sortable={true} />
                    <Column field="LastName" header={t('First_Responder.Last Name')} sortable={true} /> */}
                    <Column field="EmailId" header={t('First_Responder.Email')} sortable={true} className="wordBreakLine"></Column>
                    <Column field="Phone" header={t('First_Responder.Phone Number')} sortable={true} className="wordBreakLine"></Column>
                    {/* <Column field="Proffession" header="Proffession" sortable={true}></Column>
                    <Column field="UserStatus" header="User Status" sortable={true}></Column> */}
                    <Column field="AlarmStatus" header={t('First_Responder.Alarm status')} sortable={true} className="wordBreakLine"></Column>
                    <Column field="Phone" header={t('First_Responder.User Position')} body={this.formatUserPos} sortable={true} className="wordBreakLine" />
                    <Column field="Action" header={t('First_Responder.Action')} sortable={true} className="wordBreakLine"></Column>
                    <Column field="DefibCreatedDate"  header={t('First_Responder.Defibrillator Position')} body={this.formatDefibPos} sortable={true} className="wordBreakLine" />
                    <Column field="Distance" header={t('First_Responder.Distance')} sortable={true} className="wordBreakLine" ></Column>

                    <Column field="UpdatedTime" header={t('First_Responder.Status Update Time')} body={this.formatUpdatedDate} sortable={true}></Column>
                    <Column field="ClosedDate" body={this.formatClosedDate} header={t('First_Responder.Arrival Time')} sortable={true} className="wordBreakLine" />

                    <Column sortable={true} headerClassName="hideheader" body={this.actionColumn2} header="Logs"  />

                </DataTable>
            </div>
        );
    }
    changeRegion = (e) => {
        let value = e.target.value;
        let payload = {
            RegionId: value,
            IsShowAllAlarm: value == 0 ? true : false,
            SortField: "CreatedDate",
    SortOrder: 2
        }
        this.state.RegionId = value.toString();
        this.setState({ RegionId: value.toString() });

        this.props.getUserList(payload)

        // sleep(3000).then(() => {
        //     console.log("setstate",this.state);
        // })
    }
    onPage = (event) => {
       
		   let payload = {
            RegionId:  this.state.RegionId == '' ? (this.props.incomingAlarmList.regionList.length > 0 ? this.props.incomingAlarmList.regionList[0].ID : null) : this.state.RegionId,
            IsShowAllAlarm: this.state.RegionId == 0 ? true : false,
              PageNumber: event.page+1,
            PageSize: event.rows,
            SearchName:this.state.globalFilter,
                SortField: this.state.sortField,
            SortOrder: this.state.sortOrder==-1 ?2 :this.state.sortOrder,
        }
       

        this.props.getUserList(payload)
	};
     onSort = (event) => {
        
        this.state.sortField=event.sortField;
        this.state.sortOrder=event.sortOrder;
        this.setState({sortOrder:event.sortOrder,
            sortField:event.sortField
        })
    let payload = {
            RegionId:  this.state.RegionId == '' ? (this.props.incomingAlarmList.regionList.length > 0 ? this.props.incomingAlarmList.regionList[0].ID : null) : this.state.RegionId,
            IsShowAllAlarm: this.state.RegionId == 0 ? true : false,
             SortField: event.sortField,
            SortOrder: event.sortOrder==-1 ?2 :event.sortOrder,
            SearchName:this.state.globalFilter
        }
         this.props.getUserList(payload);
      

    console.log('ee',this.state)
   
		 
	};
       onSearch = (event) => {
       
		   let payload = {
            RegionId:  this.state.RegionId == '' ? (this.props.incomingAlarmList.regionList.length > 0 ? this.props.incomingAlarmList.regionList[0].ID : null) : this.state.RegionId,
            IsShowAllAlarm: this.state.RegionId == 0 ? true : false,
             SearchName:event.target.value ,
              //SortField: this.state.sortField,
            //SortOrder: this.state.sortOrder==-1 ?2 :this.state.sortOrder,
        }
       

        this.props.getUserList(payload)
	};
    render() {
        const { t } = this.props;
    
        var imageListData = [];
        var updatedAlarmStatusListData = [];
        imageListData = this.props.incomingAlarmList.imageList;
        updatedAlarmStatusListData=this.props.incomingAlarmList.alarmReceiverList;
       
        let  regionListOption;
      let regionList=this.props.incomingAlarmList.regionList;
      if(regionList){
          regionListOption = regionList.map((item) =>
                <option style={{background : '#f5f1f1'}} value={item.ID} key={item.ID}>{item.RegionName}</option>
            );
        }
        var UserData= updatedAlarmStatusListData.length > 0 ? updatedAlarmStatusListData[0].FirstName + " " + updatedAlarmStatusListData[0].LastName : '';
        var IsLifeguardPerformedCPR=updatedAlarmStatusListData.length > 0 ? updatedAlarmStatusListData[0].IsLifeguardPerformedCPR:false;
        var IsLifeGuardUseDefibrillator=updatedAlarmStatusListData.length > 0 ? updatedAlarmStatusListData[0].IsLifeGuardUseDefibrillator:false;
        var refLoader=<span>
            <i class="fas fa-circle-notch fa-spin"></i>
        </span>
        var IsLifeguardPerformedCPR1=updatedAlarmStatusListData.length > 0 ? <span>
           <p style={{fontWeight:'bolder'}}>{t('Lifeguard performed CPR?')} :{IsLifeguardPerformedCPR==true?'Yes':'No'}</p>
        </span>:null;
        var IsLifeGuardUseDefibrillator1=updatedAlarmStatusListData.length > 0 ? <span>
      <p style={{fontWeight:'bolder'}}>{t('Lifeguard used a defibrillator')} (AED)? :{IsLifeGuardUseDefibrillator==true?'Yes':'No'}</p>

        </span>:null;
        var RefreshLabel='Last Refresh:'
        let refreshtime=this.props.incomingAlarmList.isLoading==false ? new Date().toLocaleTimeString() :''
         var refreshButtonData=<span>
                   <button disabled={this.props.incomingAlarmList.isLoading==true} onClick={() => { this.RefreshData() }} style={{outline:'none',border:'none' }} type="button"  className="notification-badge btn btn-primary">Refresh<span className="badge bg-secondary"></span></button>
                                    <span style={{marginLeft:'1rem' }} >{refreshtime ? RefreshLabel + refreshtime :refLoader }</span>
                </span>
            
        var header = <div className="search-name">
            <i className="fa fa-search" style={{ margin: '4px 4px 0 0' }}></i>
            <InputText type="text" onInput={(e) => {this.setState({ globalFilter: e.target.value });this.onSearch(e)}} placeholder={t('First_Responder.Search')} size="50" />
        </div>;
        return (
            <div>
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Menu.incoming alarm list')}</h2>
                </div>
                <div className=" forms-panel w3-last-form">
                    <div className="forms add-device">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">
                                 <div className="text-left m-b-25 ">


                                    <select id="regionData" style={{ fontSize: 'large', padding: '7px' }}
                                        onChange={this.changeRegion}
                                        placeholder="Select"
                                        ref="regionData"
                                        name={'RegionId'}
                                    >
                                        {regionListOption}
                                        <option style={{ background: 'red', color: 'white' }} value={0} key={0}>{t('Monthly Report.AllRegions')}</option>
                                    </select>
                                </div>
                            {refreshButtonData}

                                <div className="w3l_search">

                                    {header}
                                </div>
                                 {/* <div className="w3l_search">
                                <button style={{ marginLeft: '60%',marginTop:'-2rem',outline:'none',border:'none' }} type="button"  class="notification-badge btn btn-primary">Refresh<span class="badge bg-secondary"></span></button>

                                   
                                </div> */}
                                
                                <div className="devicestable">
                                    <br />

                                    <DataTable
                                        className="table"
                                        value={this.props.incomingAlarmList.alarmList}
                                        //loading={this.props.incomingAlarmList.isLoading}
                                        lazy
                                        first={(this.props.incomingAlarmList.pageNumber -1) * this.props.incomingAlarmList.pageSize}
                                        onPage={this.onPage}
                                        rowsPerPageOptions={[5, 10, 25, 50]} 
                                        paginator 
                                         rows={this.props.incomingAlarmList.pageSize} totalRecords={this.props.incomingAlarmList.totalRecord|| 0}
                                       
                                        
                  
        
        removableSort
        onSort={this.onSort}
        
        sortField={this.state.sortField}
            sortOrder={this.state.sortOrder}

                                         globalFilter={this.state.globalFilter}
                                        // rowClassName={this.rowClassName}
                                        rowExpansionTemplate={this.rowExpansionTemplate}
                                        onRowToggle={(e) => this.setState({ expandedRows: e.data })}
                                        expandedRows={this.state.expandedRows}
                                        emptyMessage={t('Feedback Setting.No records found')}
                                    >
                                        <Column expander style={{ width: '3em' }} />
                                        <Column field="MissionId" header={t('Setting.Mission Id')} sortable={true} className="wordBreakLine" />
                                        <Column field="AlarmCategory" header={t('First_Responder.Alarm Category')} sortable={true} />
                                        {/* <Column field="AlarmStatus" header={t('First_Responder.Alarm Status')} sortable={true} /> */}

                                        <Column field="FirstName" header={t('First_Responder.Patient Name')} body={this.patientFullname} sortable={true} />
                                        {/* <Column field="EmailId" header={t('First_Responder.Email')} sortable={true} /> */}
                                        <Column field="PhoneNumber" header={t('First_Responder.Phone Number')} sortable={true} />
                                        <Column field="Street" body={this.formatAddressAlarm} header={t('First_Responder.Address')} className="wordBreakLine"  />
                                        <Column field="Floor" body={this.formatUserPos1} header={t('First_Responder.Alarm Position')} className="wordBreakLine" />
                                        {/* <Column field="Street" header={t('First_Responder.Street')} sortable={true} />
                                        <Column field="Floor" header={t('First_Responder.Floor')} sortable={true} />
                                        <Column field="City" header={t('First_Responder.City')} sortable={true} /> */}
                                         {/* <Column field="PosLat" header={t('First_Responder.Latitude')} sortable={true} className="wordBreakLine" />
                                        <Column field="PosLon" header={t('First_Responder.Longitude')} sortable={true} className="wordBreakLine" /> */}
                                        {/* <Column field="Country" header="Country" sortable={true} /> */}
                                        <Column field="CreatedDate" body={this.formatCreatedDate} header={t('First_Responder.Send Alarm Date')} sortable={true} />
                                        <Column field="UpdatedTime" body={this.formatUpdatedDate} header={t('First_Responder.Updated Alarm Date')} sortable={true} />
                                        <Column sortable={true} headerClassName="hideheader" body={this.actionColumn} header={t('First_Responder.Action')}  />
                                    </DataTable>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <Modal open={this.state.open}  onClose={this.closeModal} center classNames={{modal: "imageListModal"}}> 
                    <div className="">
                        <div className="progressbar-heading grids-heading">
                                 <h2>{t('First_Responder.Image List')}</h2>
                        </div>

                            <div className="">
                                <div className="forms add-device setting-panel">
                                    <div className="widget-shadow">
                                        <div className=" panel-body-inputin">
                                            
                                        <DataTable value={imageListData} responsiveLayout="scroll" emptyMessage={t('Feedback Setting.No records found')}>
                                            
                                            <Column field="MissionId" header={t('Setting.Mission Id')} sortable={true} className="wordBreakLine" />
                                            <Column field="FirstName" header={t('First_Responder.First Name')} sortable={true} />
                                            <Column field="LastName" header={t('First_Responder.Last Name')} sortable={true} />
                                            <Column field="EmailId" header={t('First_Responder.Email')} sortable={true} className="wordBreakLine"></Column>
                                            {/* <Column field="PhoneNumber" header={t('First_Responder.Phone Number')} sortable={true} className="wordBreakLine"></Column> */}
                                            <Column field="CreatedDate" body={this.formatCreatedDate} header={t('First_Responder.Created Date')} sortable={true} className="wordBreakLine" />
                                            <Column field="Image" header={t('First_Responder.Image')} body={this.showImage} sortable={true} />
                                            <Column sortable={true}  body={this.actionColumn1} header={t('First_Responder.Action')}  />
                                        </DataTable>

                                        </div>
                                    </div>
                                </div>      
                           
                            </div>                           
                           
                        
                    </div>
                </Modal>


                <Modal open={this.state.openAlarm}  onClose={this.closeModal2} center classNames={{modal: "UpdateAlarmStatusModal"}}> 
                    <div className="">
                        <div className="progressbar-heading grids-heading">
                        <h2>{t('First_Responder.User Tracking Log')}</h2>
                         <p style={{fontSize:'large',fontWeight:'bolder'}}>{UserData}</p>
                         {IsLifeguardPerformedCPR1}
                         {IsLifeGuardUseDefibrillator1}
                           


                        </div>

                            <div className="">
                                <div className="forms add-device setting-panel">
                                    <div className="widget-shadow">
                                        <div className=" panel-body-inputin">
                                            
                                        <DataTable value={updatedAlarmStatusListData} responsiveLayout="scroll" scrollable scrollHeight="400px" style={{ minWidth: '50rem' }} emptyMessage={t('Feedback Setting.No records found')}>
                                        {/* <Column field="FirstName" header={t('First_Responder.Patient Name')} body={this.patientFullname} sortable={true} /> */}
                                        <Column field="AlarmStatus" header={t('First_Responder.Alarm status')} sortable={true} className="wordBreakLine" style={{ width: '120px' }}></Column>
                                        <Column field="DefibCreatedDate" header={t('First_Responder.User Position')} body={this.formatUserPos} sortable={true} className="wordBreakLine" style={{ width: '180px' }}/>
                                        <Column field="Action" header={t('First_Responder.Action')} sortable={true} className="wordBreakLine" style={{ width: '150px' }}/>
                                        <Column field="DefibCreatedDate"  header={t('First_Responder.Alarm Position')} body={this.formatAlarmPos} sortable={true} className="wordBreakLine" style={{ width: '180px' }}/>
                                            
                                            <Column field="DefibCreatedDate"  header={t('First_Responder.Defibrillator Position')} body={this.formatDefibPos} sortable={true} className="wordBreakLine" style={{ width: '180px' }}/>
                                            <Column field="Distance" header={t('First_Responder.Distance')} sortable={true} className="wordBreakLine" style={{ width: '150px' }} />
                                            {/* <Column field="PhoneNumber" header={t('First_Responder.Phone Number')} sortable={true} className="wordBreakLine"></Column> */}
                                            <Column field="UpdatedTime" header={t('First_Responder.Status Update Time')} body={this.formatUpdatedDate1} sortable={true} className="wordBreakLine" style={{ width: '180px' }}></Column>
                                            <Column field="ClosedDate" body={this.formatClosedDate} header={t('First_Responder.Arrival Time')} sortable={true} className="wordBreakLine" style={{ width: '150px' }}/>
                                        </DataTable>

                                        </div>
                                    </div>
                                </div>      
                           
                            </div>                           
                           
                        
                    </div>
                </Modal>
            </div>
        )
    }
}
export default withNamespaces()(withRouter(IncomingAlarmListComponent));
